import { jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('LicenseQuota')
export class LicenseQuota {
	constructor(public quota: number) {}

	get isRestricted() {
		return typeof this.quota == 'number' && this.quota >= 0
	}

	toString() {
		return this.isRestricted ? `Max. ${this.quota}` : 'Unlimited'
	}
}
